export enum FunctionControlStatus {
    NotSet = 0,
    Active = 1,
    Terminated = 2
}